/** Shopify CDN: Minification failed

Line 19:4 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 20:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 30:6 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 31:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 34:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:6 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 53:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 56:0 Transforming const to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
      }

      // Helper to wait for user input
      async askUpsell(message) {
        const overlay = document.getElementById('upsell-modal-overlay');
        const text = document.getElementById('upsell-modal-text');
        const yesBtn = document.getElementById('upsell-yes');
        const noBtn = document.getElementById('upsell-no');

        overlay.style.display = 'flex';
        
        // Use innerHTML so the <br> renders as a line break
        text.innerHTML = message;

        return new Promise((resolve) => {
          yesBtn.onclick = () => { overlay.style.display = 'none'; resolve(true); };
          noBtn.onclick = () => { overlay.style.display = 'none'; resolve(false); };
        });
      }

      async onSubmitHandler(evt) {
        console.log("PRODUCT ADDED");
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // 1. Setup Data
const isProductPage = window.location.pathname.includes('/products/');

// Use document for product pages, otherwise scope to 'this'
const shDataEl = isProductPage 
    ? document.getElementById('second-hand-data') 
    : this.querySelector?.('#second-hand-data');

// Parse with a safety check for empty/missing elements
const shData = shDataEl?.textContent 
    ? JSON.parse(shDataEl.textContent) 
    : { isSecondHand: false };
        
        const items = [];
        const mainVariantId = this.form.querySelector('[name=id]').value;
        const mainQty = parseInt(this.closest('.product__info-container')?.querySelector(`input[name="quantity"]`)?.value || 1);
        let upsellTitleForMain = null;

        // 2. Logic Branching
        if (shData.isSecondHand) {
          // --- 2nd Hand Workflow ---
          // Popup 1: Battery (Only if metafield exists)
          if (shData.batteryVariantId && shData.batteryVariantId !== "null") {
            // Use the price from our JSON data in the question
            const healthPercent = shData.batteryHealth ? `${shData.batteryHealth}%` : 'low';
            const batteryQuestion = `<strong>Note:</strong> This device's battery health is at ${healthPercent}. <br><br>Do you want a battery replacement for only ${shData.batteryPrice}?`;
  
            const addBattery = await this.askUpsell(batteryQuestion);
            
            if (addBattery) {
              items.push({ 
                id: shData.batteryVariantId, 
                quantity: mainQty,
                properties: {
                  "Note": `${shData.productTitle}`
                } 
              });
            }
          }

          // Popup 2: Insurance (Only if metafield exists)
          if (shData.insuranceVariantId && shData.insuranceVariantId !== "null") {
            // Inject the insurance price into the question
            const insuranceQuestion = `<strong>Note:</strong>By default, this product has a FREE SHIELD Insurance. <br><br>Do you want to upgrade to SHIELD GOLD Insurance for ${shData.insurancePrice}?`;
            
            const addInsurance = await this.askUpsell(insuranceQuestion);
            
            if (addInsurance) {
              upsellTitleForMain = shData.insuranceTitle;
              items.push({
                id: shData.insuranceVariantId,
                quantity: mainQty,
                properties: { 
                  "Note": `${shData.productTitle}` 
                }
              });
            } else {
              upsellTitleForMain = "SHIELD (FREE)";
            }
          }
        } else {
          // --- Normal Workflow ---
          const upsellEl = this.querySelector('c-upsell') || document.querySelector('c-upsell');
          if (upsellEl && upsellEl.querySelector('input[type="checkbox"]').checked) {
            upsellTitleForMain = upsellEl.dataset.upsellTitle;
            items.push({
              id: upsellEl.dataset.variantId,
              quantity: mainQty,
              properties: { Note: upsellEl.dataset.propertyTemplate.replace('{product}', upsellEl.dataset.productTitle) }
            });
          }
        }

        // 3. Add Main Product
        items.push({
          id: mainVariantId,
          quantity: mainQty,
          properties: upsellTitleForMain ? { Insurance: upsellTitleForMain } : {},
        });

        // 4. Start Loading and API Call
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items,
            sections: this.cart ? this.cart.getSectionsToRender().map((s) => s.id) : [],
            sections_url: window.location.pathname
          })
        })
        .then(res => res.json())
        .then(response => {
          if (response.status) throw new Error(response.description);
          if (!this.cart) { window.location = window.routes.cart_url; return; }
          this.cart.renderContents(response);
        })
        .catch(e => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty');

          if (!this.error)
            this.submitButton.removeAttribute('aria-disabled');

          this.querySelector('.loading__spinner').classList.add('hidden');

          CartPerformance.measureFromEvent("add:user-action", evt);
        });
      }
    }
  );
}